/* NELLAE — cart drawer. Re-renders through the Section Rendering API; works as a plain link to /cart without JS. */
(function () {
  'use strict';

  var Nellae = (window.Nellae = window.Nellae || {});
  var SECTION = 'nellae-cart-drawer';

  var config = function () { return Nellae.config || { routes: {}, strings: {} }; };
  var drawer = function () { return document.querySelector('[data-nellae-cart-drawer]'); };

  var updateCount = function (count) {
    document.querySelectorAll('[data-nellae-cart-count]').forEach(function (el) {
      el.textContent = String(count);
      el.hidden = count < 1;
    });
    document.querySelectorAll('[data-nellae-cart-open]').forEach(function (el) {
      var label = (config().strings.openCart || '').replace('[count]', String(count));
      if (label) el.setAttribute('aria-label', label);
    });
  };

  var cart = (Nellae.cart = {
    open: function () {
      var dialog = drawer();
      if (!dialog) { window.location.href = config().routes.cart; return; }
      if (Nellae.openDialog && Nellae.openDialog(dialog)) {
        var heading = dialog.querySelector('#NellaeCartDrawerTitle');
        if (heading) heading.focus();
      }
    },

    renderSections: function (sections) {
      if (!sections || !sections[SECTION]) return;
      var doc = new DOMParser().parseFromString(sections[SECTION], 'text/html');
      var fresh = doc.querySelector('[data-nellae-cart-root]');
      var current = document.querySelector('[data-nellae-cart-drawer] [data-nellae-cart-root]');
      if (!fresh || !current) return;
      current.innerHTML = fresh.innerHTML;
      var contents = current.querySelector('[data-nellae-cart-contents]');
      if (contents) updateCount(parseInt(contents.getAttribute('data-cart-count'), 10) || 0);
    },

    refresh: function () {
      return fetch(window.location.pathname + '?sections=' + SECTION, { credentials: 'same-origin' })
        .then(function (response) { return response.json(); })
        .then(function (sections) { cart.renderSections(sections); })
        .catch(function () { /* keep the server-rendered contents */ });
    },

    setMessage: function (text) {
      var el = document.querySelector('[data-nellae-cart-drawer] [data-nellae-cart-message]');
      if (!el) return;
      el.textContent = text;
      el.hidden = !text;
    },

    setError: function (root, text) {
      var el = root.querySelector('[data-nellae-cart-error]');
      if (!el) return;
      el.textContent = text;
      el.hidden = !text;
    },

    remove: function (key, root) {
      root.classList.add('is-loading');
      return fetch(config().routes.cart_change + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0, sections: SECTION, sections_url: window.location.pathname })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart change failed');
          return response.json();
        })
        .then(function (data) {
          if (root.hasAttribute('data-nellae-cart-page')) { window.location.reload(); return; }
          cart.renderSections(data.sections);
        })
        .catch(function () { cart.setError(root, config().strings.cartError || ''); })
        .then(function () { root.classList.remove('is-loading'); });
    }
  });

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-nellae-cart-open]');
    if (opener && drawer()) {
      event.preventDefault();
      cart.setMessage('');
      cart.open();
      cart.refresh();
      return;
    }
    var remover = event.target.closest('[data-nellae-remove]');
    if (remover) {
      var root = remover.closest('[data-nellae-cart-root]');
      if (!root) return;
      event.preventDefault();
      cart.remove(remover.getAttribute('data-nellae-remove'), root);
    }
  });
})();
